var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "feedback 3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.375 15.7501H37.1251C37.7469 15.7501 38.2501 15.2469 38.2501 14.625C38.2501 14.0032 37.7469 13.5 37.1251 13.5H12.375C11.7532 13.5 11.25 14.0032 11.25 14.625C11.2501 15.247 11.7533 15.7501 12.375 15.7501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.875 27H12.375C11.7532 27 11.25 27.5032 11.25 28.125C11.25 28.7469 11.7532 29.2501 12.375 29.2501H25.875C26.4969 29.2501 27.0001 28.7469 27.0001 28.125C27.0001 27.5032 26.4969 27 25.875 27Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M49.6934 6.75004C49.6282 6.75004 49.565 6.76638 49.5001 6.76944V6.75004C49.5001 4.26825 47.4808 2.25 45 2.25H4.50004C2.0193 2.25 0 4.26825 0 6.75004V50.625C0 51.0799 0.274641 51.4907 0.694301 51.6643C0.832781 51.7225 0.97991 51.7501 1.12493 51.7501C1.41718 51.7501 1.70501 51.6358 1.92037 51.4205L12.8408 40.5H45C47.4808 40.5 49.5001 38.4819 49.5001 36V17.3403L52.7388 14.102C52.7388 14.102 52.7388 14.1021 52.7388 14.101C53.5408 13.299 54 12.1894 54 11.0566C54 8.68148 52.0687 6.75004 49.6934 6.75004ZM47.25 36C47.25 37.2403 46.2414 38.25 45 38.25H12.375C12.0762 38.25 11.7905 38.3686 11.5795 38.5796L2.24996 47.9092V6.75004C2.24996 5.50972 3.25856 4.50007 4.49993 4.50007H44.9999C46.2415 4.50007 47.25 5.50972 47.25 6.75004V7.51848C47.0364 7.66529 46.8321 7.82677 46.648 8.01123L34.4073 20.25H12.375C11.7531 20.25 11.2499 20.7532 11.2499 21.3751C11.2499 21.9969 11.7531 22.5001 12.375 22.5001H32.6023L31.522 27.9043C31.4473 28.2735 31.5637 28.6547 31.8296 28.9205C32.0428 29.1337 32.3306 29.2501 32.6251 29.2501C32.6976 29.2501 32.7723 29.2424 32.8448 29.2282L38.4676 28.1031C38.6873 28.0592 38.8873 27.9526 39.0433 27.7955L47.25 19.59V36ZM37.6941 25.964L34.0599 26.6913L34.7872 23.0527L44.9995 12.8403L47.9091 15.7499L37.6941 25.964ZM51.1479 12.5113L49.5 14.1592L46.5902 11.2494L48.2387 9.60096C48.621 9.21969 49.1505 9 49.6933 9C50.8271 9 51.7499 9.92285 51.7499 11.0566C51.75 11.5972 51.5302 12.1279 51.1479 12.5113Z",
    fill: "white"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep2Icon);
export default __webpack_public_path__ + "static/media/step2-icon.6269db67863aa351c36869e8fcbab174.svg";
export { ForwardRef as ReactComponent };